@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId">{{ label() }}</label>
  <lib-textarea-input
    [error]="showError"
    [controlId]="inputId"
    [rows]="rows()"
    [formControl]="inputFormControl()"
    [placeholder]="placeholder() ?? ''">
  </lib-textarea-input>
  <div class="d-flex align-items-center">
    <div class="d-flex flex-column gap-1">
      @if (hintText()) {
        <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
          {{ hintText() }}
        </div>
      }
      @if (showError && !(inputFormControl().errors?.['no-error-message'] === true)) {
        <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
      }
    </div>
    @if (maxCharacters() !== null) {
      <div class="ms-auto character-count" [class.character-count-error]="charCount() > (maxCharacters() ?? 0)">
        {{ charCount() | number }}/{{ maxCharacters() | number }}
      </div>
    }
  </div>
</div>
